var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"content"},[_c('div',{staticClass:"img-ui",class:{smallImg:_vm.smallImg}},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }